import axios from 'axios';

export const API = axios.create({
	headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

API.interceptors.response.use(
	response => {
		return response;
	},
	error => {
		return Promise.reject(error.response.status);
	},
);

export const links = {
	general: {
		checkAuth: '/api/session/init',
		logOut: '/api/logout',
		logIn: '/api/auth/go?returnTo=',
		heartBeat: '/api/session/heartbeat',
	},
	session: {
		list: '/api/supportsession/list',
		cancel: (id: string) => `/api/supportsession/${id}/cancel`,
		remove: (id: string) => `/api/supportsession/${id}/remove`,
		details: (id: string) => `/api/supportsession/${id}/getstatus`,
		accounts: (id: string) => `/api/session/info/${id}/getaccounts`,
		accountData: (id: string, account: string) => `/api/session/info/${id}/account/${account}/summary`,
		planOverview: (id: string, account: string) => `/api/session/info/${id}/account/${account}/planoverview`,
		paymentSettings: (id: string, account: string) => `/api/session/info/${id}/account/${account}/paymentsettings`,
		profileData: (id: string) => `/api/profiledata/${id}/getdata`,
		loginLogs: (id: string, options: string) => `/api/profiledata/${id}/loginlogs${options}`,
		sessionTick: (id: string) => `/api/supportsession/${id}/touch`,
		loginAsSupport: (id: string, account: string) => `/api/supportlogin/${id}/account/${account}/getstates`,
		checkLoginAccess: '/api/supportlogin/login',
		saveNote: (id: string) => `/api/supportsession/${id}/notes/save`,
		getReasons: (id: string, account: string) => `/api/supportsession/${id}/notes/get?sessionEntity=${account}`,
		getCaspioIdStatuses: (id: string) => `/api/profiledata/${id}/getcaspioidstate`,
		getSessionHistory: (sessionId: string, account: string, page: number, pageSize = 100) =>
			`/api/supportsession/${sessionId}/notes/gethistory?sessionEntity=${
				account ? `Account:${account}` : 'CaspioID'
			}&page=${page}&pageSize=${pageSize}`,
		getSessionDetails: (id: string) => `/api/supportsession/sessionDetails/${id}/get`,
		openSessionDetailsLookupSession: '/api/supportsession/sessionDetails/createLookupForAccount',
	},
	shareSession: {
		list: (id: string) => `/api/supportsession/${id}/listUsersForSharing`,
		share: (id: string) => `/api/supportsession/${id}/shareSession`,
		accept: (id: string) => `/api/supportsession/${id}/acceptSharedSession`,
		decline: (id: string) => `/api/supportsession/${id}/declineSharedSession`,
	},
	mainFlow: {
		checkPin: '/api/supportsession/new/mainflow/verifypin',
		getEmailList: '/api/supportsession/new/mainflow/getemails',
		confirmEmail: '/api/supportsession/new/mainflow/confirmemail',
		chooseSource: '/api/supportsession/new/mainflow/choosesessionsource',
		setSource: '/api/supportsession/new/mainflow/setsesessionsource',
	},
	emailFlow: {
		getContacts: '/api/supportsession/new/emailflow/getcontacts',
		goToVerifyPin: '/api/supportsession/new/emailflow/gotoverifypin',
		goBackToSecondStep: '/api/supportsession/new/emailflow/gotosendpin',
		sendMailPin: '/api/supportsession/new/emailflow/sendemailpin',
		sendSmsPin: '/api/supportsession/new/emailflow/sendsmspin',
		verifyEmail: '/api/supportsession/new/emailflow/verifyemail',
		verifyPin: '/api/supportsession/new/emailflow/verifyPinWithSessionId',
		chooseSource: '/api/supportsession/new/emailflow/choosesessionsource',
		setSource: '/api/supportsession/new/emailflow/setsesessionsource',
	},
	history: {
		supportHistory: '/api/odata/supportSessionHistory',
		accessLogs: (session: string, account: string) => `/api/accountloginhistory/${session}/account/${account}/get`,
		options: '/api/supportsession/listCriteriaOptions',
		accessLogsOptions: '/api/accountloginhistory/account/listCriteriaOptions',
	},
	employee: {
		users: (hours: number) => `api/odata/EmployeeDashboardUsers?lastHoursCount=${hours}`,
		monthlyStats: 'api/EmployeeDashboardUsers/getemployeemonthlystats',
	},
	users: {
		odata: (session: string, account: string) => `/api/caspioidaccountusers/${session}/account/${account}/get`,
		options: '/api/caspioidaccountusers/listCriteriaOptions',
		count: (session: string, account: string) => `api/session/info/${session}/account/${account}/userscount`,
	},
	datapages: {
		odata: (session: string, account: string) => `api/accountdatapages/${session}/account/${account}/get`,
		options: 'api/accountdatapages/listCriteriaOptions',
		count: (session: string, account: string) =>
			`api/accountdatapages/${session}/account/${account}/datapagescount`,
	},
	accountsSearch: {
		search: (query: string) => `api/accountsearch/search/${query}`,
		openSession: 'api/accountsearch/createAccountLookUpSession',
	},
	updateResources: (sessionId: string, accountName: string) =>
		`api/session/info/${sessionId}/account/${accountName}/planoverview`,
	openHubspotTask: 'api/hubspot/getcreatetasklinkdeal',
};

export const LOGGED_OUT_LINK = '/logged-out';
export const LOGIN_LINK = '/login';
export const HOME_LINK = '/sessions/verify-pin/';
export const SYSTEM_ERROR_LINK = '/system-error';

export const PUBLIC_PATHS = ['/access-denied', '/authorization-failed', '/logged-out', '/login'];
